"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondaryButtons = void 0;
var material_1 = require("@mui/material");
exports.secondaryButtons = [
    {
        props: { variant: 'secondaryDefault' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.secondary.main,
                border: "1px solid ".concat(theme.palette.secondary.main),
                '&:hover': {
                    backgroundColor: theme.palette.neutrals.white,
                },
                '&:focus': {
                    backgroundColor: theme.palette.neutrals.white,
                },
                '&:active': {
                    color: theme.palette.text.light,
                    backgroundColor: theme.palette.secondary.dark,
                    border: "1px solid ".concat(theme.palette.neutrals.white),
                },
                '&:disabled': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.neutral, 0.3),
                    color: theme.palette.text.disabled,
                    border: "1px solid ".concat(theme.palette.text.disabled),
                },
            });
        },
    },
    {
        props: { variant: 'secondaryHC' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.text.light,
                border: "1px solid ".concat(theme.palette.neutrals.white),
                '&:hover': {
                    color: theme.palette.secondary.main,
                    backgroundColor: theme.palette.neutrals.white,
                    border: "1px solid ".concat(theme.palette.neutrals.white),
                },
                '&:focus': {
                    color: theme.palette.secondary.main,
                    backgroundColor: theme.palette.neutrals.white,
                    border: "1px solid ".concat(theme.palette.neutrals.white),
                },
                '&:active': {
                    color: theme.palette.secondary.main,
                    backgroundColor: theme.palette.neutrals.light,
                    border: "1px solid ".concat(theme.palette.neutrals.white),
                },
                '&:disabled': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.neutral, 0.3),
                    color: theme.palette.text.disabled,
                    border: "1px solid ".concat(theme.palette.text.disabled),
                },
            });
        },
    },
];
